import { render, staticRenderFns } from "./FailureList.vue?vue&type=template&id=b15869ce&scoped=true"
import script from "./FailureList.vue?vue&type=script&lang=js"
export * from "./FailureList.vue?vue&type=script&lang=js"
import style0 from "./FailureList.vue?vue&type=style&index=0&id=b15869ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b15869ce",
  null
  
)

export default component.exports